module.exports = __webpack_public_path__ + "static/media/logo2.669d825c.svg";